import React from "react";
var __jsx = React.createElement;
import { Drawer } from "vaul";
import useHelpers from "@hooks/useHelpers";
import useBoolean from "@hooks/useBoolean";
import SAR from "@componentsShared/SAR/SAR";
import { Icon } from "@syarahtech/ui";
import DrawerPaymentInfo from "@/pages/checkout/components/PaymentInfo/DrawerPaymentInfo";
import CarInfoShimmer from "@/pages/checkout/components/HeadingSteps/MobileCarInfo/CarInfoShimmer";
var MobileCarInfoV2 = function MobileCarInfoV2(_ref) {
  var _checkoutOrderV2$post, _checkoutOrderV2$post2, _checkoutOrderV2$post3;
  var checkoutOrderV2 = _ref.checkoutOrderV2,
    hideData = _ref.hideData,
    className = _ref.className,
    _onClickInfoIcon = _ref.onClickInfoIcon,
    isCancelled = _ref.isCancelled;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var drawer = useBoolean();
  var carLogo = checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$post = checkoutOrderV2.post) === null || _checkoutOrderV2$post === void 0 ? void 0 : _checkoutOrderV2$post.make_logo;
  var carTitle = checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$post2 = checkoutOrderV2.post) === null || _checkoutOrderV2$post2 === void 0 ? void 0 : _checkoutOrderV2$post2.post_title;
  var totalPrice = checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$post3 = checkoutOrderV2.post) === null || _checkoutOrderV2$post3 === void 0 ? void 0 : _checkoutOrderV2$post3.post_price;
  if (!checkoutOrderV2) {
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, /*#__PURE__*/React.createElement(CarInfoShimmer, null));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: ["w-full flex justify-between rounded-lg border border-solid border-[#E0E0E0] bg-white px-3 py-2", className || ""].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2 w-full justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, carLogo && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-8 h-8 border border-solid border-[#E0E0E0] rounded-md overflow-hidden shrink-0"
  }, /*#__PURE__*/React.createElement("img", {
    className: "w-5 h-5 object-contain",
    src: carLogo || undefined,
    alt: ""
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-start text-[#00143C] font-bold text-xs leading-6"
  }, /*#__PURE__*/React.createElement("h3", {
    className: ""
  }, carTitle))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1 cursor-pointer",
    onClick: drawer.setTrue
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-base text-primary-new font-bold"
  }, totalPrice), /*#__PURE__*/React.createElement(SAR, {
    className: "text-primary-new"
  })), /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--arrow-drop-down-rounded",
    width: 7,
    height: 7,
    className: ["text-primary-new transition-transform duration-200", drawer.value ? "rotate-180" : "rotate-0"].join(" ")
  })))), /*#__PURE__*/React.createElement(Drawer.Root, {
    open: drawer.value,
    onOpenChange: function onOpenChange(o) {
      if (!o) drawer.setFalse();
    },
    snapPoints: [1],
    closeThreshold: 0.65
  }, /*#__PURE__*/React.createElement(Drawer.Portal, null, /*#__PURE__*/React.createElement(Drawer.Overlay, {
    className: "fixed inset-0 bg-[#071425]/50 opacity-50 z-[9998]"
  }), /*#__PURE__*/React.createElement(Drawer.Content, {
    className: "fixed bottom-0 left-0 right-0 z-[9999] bg-[#fbfbfb] rounded-t-[20px] flex flex-col outline-none max-h-[85vh]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center pt-3 pb-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-[49px] h-[5px] rounded-full bg-[#020202]"
  })), /*#__PURE__*/React.createElement("div", {
    className: "px-4 py-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-end "
  }, /*#__PURE__*/React.createElement("div", {
    onClick: drawer.setFalse,
    className: "w-7 h-7 flex items-center justify-center text-[#09090B] hover:opacity-70 cursor-pointer transition-opacity"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close",
    width: 4,
    height: 4
  })))), /*#__PURE__*/React.createElement("div", {
    className: "overflow-y-auto flex-1"
  }, /*#__PURE__*/React.createElement(DrawerPaymentInfo, {
    checkoutOrderV2: checkoutOrderV2,
    hideData: hideData,
    onClickInfoIcon: function onClickInfoIcon() {
      drawer.setFalse();
      _onClickInfoIcon === null || _onClickInfoIcon === void 0 ? void 0 : _onClickInfoIcon();
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center pb-3 pt-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-[#020202] h-[4.5px] w-[127px] rounded-full"
  }))))));
};
export default MobileCarInfoV2;